<template>
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.76 25.0932C12.5067 25.0932 12.2533 24.9999 12.0533 24.7999L3.96001 16.7066C3.57335 16.3199 3.57335 15.6799 3.96001 15.2932L12.0533 7.19991C12.44 6.81325 13.08 6.81325 13.4667 7.19991C13.8533 7.58658 13.8533 8.22658 13.4667 8.61325L6.08001 15.9999L13.4667 23.3866C13.8533 23.7732 13.8533 24.4132 13.4667 24.7999C13.28 24.9999 13.0133 25.0932 12.76 25.0932Z" fill="#292E36"/>
<path d="M27.3333 17H4.89334C4.34667 17 3.89334 16.5467 3.89334 16C3.89334 15.4533 4.34667 15 4.89334 15H27.3333C27.88 15 28.3333 15.4533 28.3333 16C28.3333 16.5467 27.88 17 27.3333 17Z" fill="#292E36"/>
</svg>

  </template>

  